import { useMemo } from "react";
import { ViewBooking } from "collins-js-sdk";

export const useBookingGrouping = (
  filteredBookings: ViewBooking[],
  sortOrder: string,
  showTimeDividers: boolean
): { [key: string]: ViewBooking[] } => {
  return useMemo(() => {
    if (!showTimeDividers) {
      return { "All Bookings": filteredBookings };
    }

    const groups: { [key: string]: ViewBooking[] } = {};

    filteredBookings.forEach((booking) => {
      let time = "No time";

      if (booking.time) {
        try {
          const timeStr = booking.time.toString();
          if (timeStr.includes(":")) {
            time = timeStr.substring(0, 5);
          } else {
            const date = new Date(booking.time);
            if (!isNaN(date.getTime())) {
              time = date.toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false
              });
            }
          }
        } catch {
          // Handle invalid booking time gracefully
          time = "Invalid time";
        }
      }

      if (!groups[time]) {
        groups[time] = [];
      }
      groups[time].push(booking);
    });

    // Sort time groups based on sortOrder
    const sortedTimeGroups = Object.entries(groups).sort(([timeA], [timeB]) => {
      if (sortOrder === "none") return 0;
      if (timeA === "No time") return 1;
      if (timeB === "No time") return -1;

      const timeAValue = new Date(`2000-01-01T${timeA}:00`).getTime();
      const timeBValue = new Date(`2000-01-01T${timeB}:00`).getTime();

      return sortOrder === "asc"
        ? timeAValue - timeBValue
        : timeBValue - timeAValue;
    });

    // Convert back to object
    const result: { [key: string]: ViewBooking[] } = {};
    sortedTimeGroups.forEach(([time, bookings]) => {
      result[time] = bookings;
    });

    return result;
  }, [filteredBookings, sortOrder, showTimeDividers]);
};
